module.exports = __webpack_public_path__ + "img/part-1-title.fce5d19c.png";